<template>
  <div v-if="show" class="modal">
    <div class="modal-mask"></div>
    <div class="modal-box">
      <div class="modal-box-title">
        {{ config.title }}
      </div>
      <div class="modal-box-subtitle">
        {{ config.subTitle }}
      </div>
      <div class="modal-box-btn" @click="config.btnFunction">
        <div class="modal-box-btn-text">{{ config.btnContent }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="less">
@import '../../assets/variable.less';
.modal {
  .flex-center(center);
  .size(100%);
  top: 0;
  left: 0;
  position: fixed;
  z-index: 12;
  background-color: transparent;
  &-mask {
    .size(100%);
    position: fixed;
    top: 0;
    left: 0;
    background: #000000;
    opacity: 0.76;
    z-index: 110;
  }
  &-box {
    z-index: 111;
    border-radius: 18px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    padding: 20px 16px 16px;
    width: 311px;
    height: 171px;
    box-sizing: border-box;

    &-title {
      color: #111111;
      font-family: PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 17px;
      line-height: 24px;
      text-align: center;
    }

    &-subtitle {
      margin-top: 10px;
      padding: 0 18px;
      color: #555555;
      font-family: PingFang SC, sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }

    &-btn {
      margin-top: 21px;
      width: 100%;
      border-radius: 20px;
      background: linear-gradient(98deg, #FFE74D 0%, #FFDD00 100%);
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      padding: 9.5px 0;

      &-text {
        color: #111111;
        font-family: PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        text-align: center;
      }
    }
  }
}
</style>
